import React from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import { generateLinkDatas } from './utils';
import { revealable } from './utils';

/**
 * MultiDataColumn.Link — the same two-line cell with the main value as a router
 * link.
 *
 * `combined` behaves exactly as it does on MultiDataColumn: one Popover around
 * the whole cell showing every line, instead of a CopyableValue per line. The
 * Alert ID column needs it for the same reason Party ID does — the id and its
 * generation date are read together, and both are clipped by the column width.
 */
const Link = ({ children, data = [], combined = false }) => {
  const content = generateLinkDatas(data, !combined);
  const cell = (
    <div>
      {content}
      {children}
    </div>
  );

  return combined ? (
    <Popover content={<div>{generateLinkDatas(revealable(data), false)}</div>}>
      {cell}
    </Popover>
  ) : (
    cell
  );
};

Link.propTypes = {
  children: PropTypes.node,
  data: PropTypes.array,
  combined: PropTypes.bool
};

export default Link;
